module.exports = __webpack_public_path__ + "static/media/team-property.a547858d.jpg";